<template id="salesmanDashboard">
  <section>
    <div>
      <div style="position: relative; text-align: center; margin: 10px 0 -20px 0; padding: 0 30px;">
        <!-- Back button positioned absolutely on the left -->
        <span v-if="this.$route.path!=='/mobile-screen'" @click="backButton"
              style="position: absolute; margin-left: -60px; top: 50%; transform: translateY(-50%); cursor: pointer;">
          <i class="fas fa-undo-alt" style="font-size:20px; color: #4285f4;"></i>
        </span>
        <!-- Centered content -->
        <div style="display: inline-block;">
          <img v-if="this.$route.path==='/field/deepdive' || this.$route.path==='/field/simple' || this.$route.path==='/field/landing'" class="d-inline-block" src='@/assets/COMPEGENCE_logo-compressed.jpeg' width="150px" height="40px"
               style="margin-bottom: -10px"/>
          <img v-else class="d-inline-block" :src=logoPath width="150px" height="40px"
               style="margin-bottom: -10px"/>
          <br>
          <b style="font-size: x-small;">
            Powered by <a style="padding:0px;" href="https://compegence.com/products">
            <i style="color: #4785ee">Fore</i>
            <i style="color: #e31717">Warn</i></a>
          </b>
        </div>
      </div>

      <!-- Mobile notice with full responsive design -->
      <div v-if="this.$route.path!=='/mobile-screen'" style="text-align: center; margin: 30px 0; width: 100%; box-sizing: border-box; padding: 0 5%;">
  <span style="
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: min(3.5vw, 14px);
    color: #666;
    background-color: #f8f9fa;
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    width: auto;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
    box-sizing: border-box;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  ">
    This screen can be embedded in mobile
  </span>
      </div>

      <!-- Modified button container with dynamic class -->
      <div style="margin-top: 30px;overflow: auto; max-height: 95vh " v-if="subMenuParam===null && this.$route.path!=='/field/deepdive' && this.$route.path!=='/field/simple' && this.$route.path!=='/mobile-screen'"
           :class="['button-container1', { 'expanded1': !menuPath }]">
        <div class="button-group1 mb-3">
          <button @click="goToDeepDive"
                  :class="['btn', 'btn-outline-primary', { 'active-btn': menuPath === 'deepdive' }]">
            Deep Dive
          </button>
          <button @click="goToSimple" :class="['btn', 'btn-outline-primary', { 'active-btn': menuPath === 'simple' }]">
            MTD QTD YTD
          </button>
          <button disabled @click="goToSimple"
                  :class="['btn', 'btn-outline-primary', { 'active-btn': menuPath === 'dummy1' }]">
            Quarter Dive
          </button>
          <button disabled @click="goToSimple"
                  :class="['btn', 'btn-outline-primary', { 'active-btn': menuPath === 'dummy1' }]">
            View Field
          </button>
          <button disabled @click="goToSimple"
                  :class="['btn', 'btn-outline-primary', { 'active-btn': menuPath === 'dummy1' }]">
            Deep Host
          </button>
        </div>
      </div>

      <div style="margin-top: 30px;overflow: auto; max-height: 95vh" v-if="this.$route.path==='/mobile-screen'"
           :class="['button-container', { 'expanded': !menuPath }]">
        <div class="button-group mb-3" v-if="reports">
          <button
              v-for="(report, index) in reports"
              :key="index"
              @click="goToMobileScreen(report.url)"
              :class="['btn', 'btn-outline-primary', 'btn-with-icon', { 'active-btn': menuPath === 'deepdive' }]"
          >
            <i :class="report.icon" aria-hidden="true"></i>
            <span class="btn-label">{{ report.label }}</span>
          </button>
        </div>
      </div>

      <div v-if="this.$route.path!=='/mobile-screen'" class="card-deck m-3">
        <div v-if="menuPath==='deepdive' || this.$route.path==='/field/deepdive'" class="card-body p-1">
          <sales-dashboard ref="salesDashboard" :id="id" :viz1="vizData[0]" :filters="filter" :sales-data="salesData"/>
        </div>

        <div v-if="menuPath==='simple' || this.$route.path==='/field/simple'" class="card-body p-1">
          <sales-dashboard-v1 ref="salesDashboardv1" :id="id" :viz1="vizData[0]" :filters="filter"
                              :sales-data="salesData"/>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import SalesDashboardV1 from "@/components/SalesDashboardV1.vue";
import SalesDashboard from "@/components/SalesDashboard.vue";
import axios from 'axios';
import {isDescendant} from "@/common/functions";

export default {
  name: "salesmanDashboard",
  components: {SalesDashboard, SalesDashboardV1},
  props: {
    screenlet: Number,
    sl: Object,
    scrnPropTime: Date,
    screenletId: String
  },
  watch: {
    $props: {
      handler() {
        this.loadSummary()
      },
      deep: true,
      immediate: true,
    },
    '$route.path': {
      handler(newPath) {
        if (newPath === '/field/deepdive') {
          console.log("inside watch")
          this.goToDeepDive();
        }
        if (newPath === '/field/simple') {
          console.log("inside watch")
          this.goToSimple();
        }
      },
      immediate: true
    }
  },
  data: () => ({
    optionValues: ['a', 'b'],
    loadViz: false,
    menuPath: '',
    salesData: [],
    filter: {},
    searching: false,
    vizData: [],
    screenName: '',
    time3: '',
    propTime: null,
    f: {
      userName: 'field_demo',
      password: 'FieldDemo@123',
    },
    id: `VIZ-${new Date().getTime()}`,
    // logoPath: null,
    subMenuParam: null,
    logoPath: null
  }),
  computed: {
    reports(){
      const mobileMenu = this.$store.state.menuMasterFlat.find(item => item.menuId === 'Mobile');
      console.log("reports",mobileMenu);
      let reports = []
      if (mobileMenu && mobileMenu.menuRenderJson) {
        reports = mobileMenu.menuRenderJson.reports;
      }
      return reports;
    }
  },
  async created() {
    console.log("this router", this.$route);

    let restrictedMenu = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
    let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];
    const menuTree = this.$store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []

    // Handle empty/undefined/null/["[]"] cases - all menus allowed
    const isAllMenusAllowed = !restrictedMenu ||
        restrictedMenu.length === 0 ||
        (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

    if (!isAllMenusAllowed) {
      const currentMenuId = this.$route.params.menuId
      const currentSubmenuId = this.$route.params.submenuId

      // Only check menu restrictions for routes that have these parameters
      if (currentMenuId || currentSubmenuId) {
        // Check if current IDs are in exclusion array
        const isExcluded = exclusionArray.includes(currentMenuId) ||
            exclusionArray.includes(currentSubmenuId)
        // If NEITHER menuId NOR submenuId is in the allowed list, block access
        // Check whether current IDs are directly allowed or descendants of allowed ones
        const isAllowed =
            restrictedMenu.includes(currentMenuId) ||
            restrictedMenu.includes(currentSubmenuId) ||
            isDescendant(menuTree, restrictedMenu, currentMenuId) ||
            isDescendant(menuTree, restrictedMenu, currentSubmenuId);

        if (!isAllowed || isExcluded) {
          window.alert("Invalid action, request please contact your Administrator")
          // You might want to redirect to user-restrict page here as well
          await this.$router.push('/user-restrict')
          return; // Stop execution
        }
      }
    }
    this.listenToRouter();
    this.getLogoPath();
  },
  mounted() {
    this.handleFirstVisitReload();
  },
  methods: {
    handleFirstVisitReload() {
      console.log("reload function called")
      const hasReloaded = localStorage.getItem('hasReloaded');

      if (!hasReloaded) {
        localStorage.setItem('hasReloaded', 'true');

        // Force a hard reload (avoids caching issues)
        window.location.reload(); // `true` forces a cache bypass (deprecated in some browsers)

        // Alternative (modern approach):
        // window.location.href = window.location.href;
      }
    },
    async goToMobileScreen(url) {
      await this.$router.push(url);
    },
    backButton() {
      console.log("back button called")
      this.$router.push('/field/landing')
      this.menuPath ='';
      this.subMenuParam = null;
      // window.location.reload();
    },
    goToDeepDive() {
      console.log("deepdive called ")
      this.menuPath = 'deepdive';
      this.subMenuParam = 'RDemo1'
      this.$router.push('/field/deepdive')
      this.loadSummary();
    },
    goToSimple() {
      this.menuPath = 'simple';
      this.subMenuParam = 'RDemo2'
      this.$router.push('/field/simple')
      this.loadSummary();
    },

    getLogoPath: function () {
      console.log('logo-path', 'load state');
      this.$store.dispatch("loadState").then((cfg) => {
        console.log("logooo", cfg.fwMClient)
        this.fwMClient = cfg.fwMClient
        this.logoPath = "/img" + this.fwMClient[0].clientLogoPath['mobile']
        console.log("client", this.fwMClient)
      })
    },
    loadSummary: function () {
      if (this.subMenuParam) {
        axios.post(`/auth/login`, this.f).then(response => {
          console.log(response);
          if (response.status === 200) {
            this.$store.commit('loggedIn', response.data['authToken']);
            // this.$store.dispatch('checkUserLogin');
            // this.$store.dispatch("loadState");
            this.$store.commit('isAppMenuAndAppHeaderDisplay', false)

            axios.get('/api/state')
                .then(res => {

                  if (res.status === 200) {
                    this.$store.commit('setState', res.data)
                    // this.getLogoPath()

                    this.propTime = new Date();
                    this.loadViz = true


                    let allVizData = this.$store.state.fwConfigScreenElement

                    if (this.screenletId) {
                      this.vizData = allVizData.filter(r => r.menuId === this.subMenuParam && r.screenletInstanceId === this.screenletId)
                    } else {
                      this.vizData = allVizData.filter(r => r.menuId === this.subMenuParam)
                    }

                    console.log("this.vizData", this.vizData);

                    var url = '/api/fetchDataWithParam/' + this.vizData[0].datasqlId + '/' + 'CommonVizClass'
                    axios.post(url, this.filter).then(resp => {
                      this.salesData = resp.data
                    })
                  }
                })
          }
        }).catch(error => {
          this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
          this.$store.commit('authError');
          this.loginFailed = !this.$store.state.serverIsDown;
          this.show = false;
        });
      }
    },
    listenToRouter: function () {
      console.log("listenToRouter is called")
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.rows = []
        $this.menuPath = ''
        $this.subMenuParam = null
        $this.time3 = ''
        setTimeout(() => {
          if($this.$route.path!=='/mobile-screen') {
            $this.loadSummary()
          }
          // $this.loadSummary($this.x)
        }, 300)

      })
    },
  }
}
</script>
<style scope>
/* Button with icon styling */
.btn-with-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
}

.btn-with-icon i {
  font-size: 1.1em;
}

.btn-label {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  flex-grow: 1;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .btn-with-icon {
    flex-direction: column;
    padding: 6px 12px;
    gap: 4px;
  }

  .btn-with-icon i {
    margin-bottom: 2px;
  }
}

/* Existing styles */
.button-group {
  display: inline-block;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: -20px;
}

.button-group button {
  min-width: 120px;
  background-color: #f0f8ff
}

.button-group1 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: -20px;
}

.button-group1 button {
  min-width: 120px;
  background-color: #f0f8ff
}

.active-btn {
  background-color: #0d6efd !important;
  color: #fff !important;
  border-color: #0d6efd !important;
}

/* New styles for expanded view */
.button-container {
  transition: all 0.3s ease;
}

.button-container.expanded {
  display: block;
  justify-content: center;
  align-items: center;
}

.button-container.expanded .button-group {
  flex-direction: column;
  gap: 30px;
}

.button-container.expanded .button-group button {
  width: 320px;
  padding: 20px 40px;
  font-size: 1.2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.button-container.expanded .button-group button:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.button-container1.expanded1 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh; /* Takes up most of the viewport */
}

.button-container1.expanded1 .button-group1 {
  flex-direction: column;
  gap: 30px;
}

.button-container1.expanded1 .button-group1 button {
  width: 300px;
  padding: 20px 40px;
  font-size: 1.2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.button-container1.expanded1 .button-group1 button:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}


</style>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->